import { useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

export default function ConfirmacionPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const estudiante = location.state?.estudiante;

  useEffect(() => {
    if (!estudiante) {
      navigate('/');
    }
  }, [estudiante, navigate]);

  if (!estudiante) {
    return null;
  }

  const planTexto = estudiante.plan_pago === 'pago_unico' 
    ? 'Pago Único de $297' 
    : '4 Pagos de $97 por semana';

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-orange-950 text-white font-['Inter',sans-serif] flex items-center justify-center px-6">
      <div className="max-w-2xl w-full">
        {/* Success Animation */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-gradient-to-br from-green-500 to-emerald-500 mb-6 animate-bounce">
            <i className="ri-check-line text-5xl text-white"></i>
          </div>
          <h1 className="text-5xl md:text-6xl font-black mb-4">
            <span className="bg-gradient-to-r from-white to-gray-300 bg-clip-text text-transparent">
              ¡Inscripción
            </span>
            <br />
            <span className="bg-gradient-to-r from-green-400 to-emerald-400 bg-clip-text text-transparent">
              Exitosa!
            </span>
          </h1>
          <p className="text-xl text-gray-400">
            Bienvenido a la Mentoría 10X con IA
          </p>
        </div>

        {/* Confirmation Details */}
        <div className="bg-gradient-to-br from-white/10 to-white/5 border border-white/20 rounded-3xl p-8 md:p-10 backdrop-blur-xl space-y-6">
          <div className="space-y-4">
            <div className="flex items-start gap-3">
              <i className="ri-user-line text-orange-400 text-xl flex-shrink-0 mt-1"></i>
              <div>
                <p className="text-sm text-gray-400">Nombre</p>
                <p className="text-lg font-semibold text-white">{estudiante.nombre_completo}</p>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <i className="ri-mail-line text-orange-400 text-xl flex-shrink-0 mt-1"></i>
              <div>
                <p className="text-sm text-gray-400">Email</p>
                <p className="text-lg font-semibold text-white">{estudiante.email}</p>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <i className="ri-price-tag-3-line text-orange-400 text-xl flex-shrink-0 mt-1"></i>
              <div>
                <p className="text-sm text-gray-400">Plan Seleccionado</p>
                <p className="text-lg font-semibold text-white">{planTexto}</p>
              </div>
            </div>
          </div>

          <div className="border-t border-white/10 pt-6">
            <h3 className="text-xl font-bold text-white mb-4">Próximos Pasos:</h3>
            <div className="space-y-3">
              <div className="flex items-start gap-3">
                <div className="w-6 h-6 flex items-center justify-center rounded-full bg-gradient-to-br from-orange-500 to-amber-500 flex-shrink-0 mt-0.5">
                  <span className="text-xs font-bold text-white">1</span>
                </div>
                <p className="text-gray-300">Revisa tu WhatsApp - Te contactaremos para coordinar el pago</p>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-6 h-6 flex items-center justify-center rounded-full bg-gradient-to-br from-orange-500 to-amber-500 flex-shrink-0 mt-0.5">
                  <span className="text-xs font-bold text-white">2</span>
                </div>
                <p className="text-gray-300">Recibirás un email con los detalles de acceso a las sesiones</p>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-6 h-6 flex items-center justify-center rounded-full bg-gradient-to-br from-orange-500 to-amber-500 flex-shrink-0 mt-0.5">
                  <span className="text-xs font-bold text-white">3</span>
                </div>
                <p className="text-gray-300">Serás agregado al grupo exclusivo de WhatsApp</p>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-6 h-6 flex items-center justify-center rounded-full bg-gradient-to-br from-orange-500 to-amber-500 flex-shrink-0 mt-0.5">
                  <span className="text-xs font-bold text-white">4</span>
                </div>
                <p className="text-gray-300">¡Prepárate para la primera sesión el 4 de Enero 2026!</p>
              </div>
            </div>
          </div>

          <div className="bg-gradient-to-r from-orange-500/10 to-amber-500/10 border border-orange-500/30 rounded-xl p-4">
            <div className="flex items-start gap-3">
              <i className="ri-calendar-event-line text-orange-400 text-xl flex-shrink-0 mt-0.5"></i>
              <div>
                <p className="text-white font-semibold mb-1">Primera Sesión</p>
                <p className="text-gray-300 text-sm">Domingo 4 de Enero 2026 • 7:00 PM - 9:00 PM (Hora del Este)</p>
              </div>
            </div>
          </div>
        </div>

        {/* Actions */}
        <div className="flex flex-col sm:flex-row gap-4 mt-8">
          <Link
            to="/"
            className="flex-1 flex items-center justify-center gap-2 bg-gradient-to-r from-orange-500 to-amber-500 text-black px-6 py-4 rounded-xl font-bold text-lg hover:shadow-2xl hover:shadow-orange-500/50 transition-all whitespace-nowrap cursor-pointer transform hover:scale-105"
          >
            <i className="ri-home-line"></i>
            Volver al Inicio
          </Link>
          <a
            href="https://wa.me/15626745958"
            target="_blank"
            rel="noopener noreferrer"
            className="flex-1 flex items-center justify-center gap-2 bg-white/5 border border-white/20 text-white px-6 py-4 rounded-xl font-semibold text-lg hover:bg-white/10 transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-whatsapp-line"></i>
            Contactar por WhatsApp
          </a>
        </div>
      </div>
    </div>
  );
}
